import {useTranslation} from 'react-i18next'
//@ts-ignore
import {CirclePicker} from 'webtic-react-color'
import {ProductColor} from '../../models/dto/common/productColor'
import {Page} from '../../models/editor/page'
import StyleSheet from '../../utils/helpers/styleSheet'
import {Select} from '../global/Select'

const styles: StyleSheet = {
  productPropertyPicker: {
    gridColumn: 'span 2',
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr',
    padding: '1.5rem',
    borderBottom: '1px solid var(--e-global-color-d70fa63)',
  },
}
interface ProductPropertyPickerProps {
  colors: ProductColor[]
  colorHandler: [ProductColor | undefined, (color: ProductColor) => void]
  pages: Page[]
  selectedPageIndex: number | undefined
  setSelectedPageIndex: React.Dispatch<React.SetStateAction<number | undefined>>
  sizes: string[] | null
  selectedSize: string
  setSelectedSize: (size: string) => void
}

export function ProductPropertyPicker({
  colors,
  colorHandler,
  pages,
  selectedPageIndex,
  setSelectedPageIndex,
  sizes,
  selectedSize,
  setSelectedSize,
}: ProductPropertyPickerProps) {
  const {t} = useTranslation()
  const [color, onColorChange] = colorHandler
  return (
    <div style={styles.productPropertyPicker}>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <span style={{paddingBottom: '1rem', fontWeight: 'bold'}}>
          {t('Szín')}
        </span>
        <CirclePicker
          colors={colors as unknown as string[]}
          color={color as unknown as string}
          onChange={(newColor: any) => {
            const realColor = colors.find(c => c.color === newColor.hex)
            if (realColor) onColorChange(realColor)
          }}
          width="100%"
        />
      </div>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        {sizes && sizes.length > 1 ? (
          <>
            <span style={{paddingBottom: '1rem', fontWeight: 'bold'}}>
              {t('Méret')}
            </span>
            <Select
              name="size"
              id="size"
              style={{width: '8rem'}}
              value={selectedSize}
              onChange={event => {
                setSelectedSize(event.target.value)
              }}
              options={sizes.map(size => ({value: size, text: size}))}
            />
          </>
        ) : null}
      </div>
      {pages.length > 0 && selectedPageIndex !== undefined ? (
        <div
          style={{
            flexDirection: 'column',
            display: 'flex',
          }}>
          <span style={{paddingBottom: '1rem', fontWeight: 'bold'}}>
            {t('Oldal')}
          </span>
          <Select
            name="page"
            id="page"
            style={{width: '8rem'}}
            value={selectedPageIndex.toString()}
            onChange={event => {
              setSelectedPageIndex(Number(event.target.value))
            }}
            options={pages.map((page, index) => ({
              value: index.toString(),
              text: t(page.text),
            }))}
          />
        </div>
      ) : null}
    </div>
  )
}
